import { render, staticRenderFns } from "./form-textarea.vue?vue&type=template&id=a47db538&scoped=true"
import script from "./form-textarea.ts?vue&type=script&lang=ts&external"
export * from "./form-textarea.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47db538",
  null
  
)

export default component.exports